module.exports = __webpack_public_path__ + "img/information-title.247faf93.png";